export default "__VITE_ASSET__DAvbfm1S__"